// Antwortform von GET /api/sam-timeline (node-app/src/routes/sam-timeline.ts).
// Seit 2026-09-16 nur noch FT-Mailings ueber Iterable (Webinar/PLX); Kennzahlen:
// anfos = zugeordnete Bestellungen, cpa_revenue = deren CPA-Wert, actual_revenue = bezahlt.

export type MailingCampaignType = 'webinar_mailing' | 'plx_mailing';

export interface SamData {
  campaign_id: string;
  send_time: string;
  subject: string;
  campaign_title: string;
  customer: string;
  product_type: string;
  campaign_type: MailingCampaignType;
  esp_source: 'iterable';
  recipients: number;
  opens: number;
  unique_opens: number;
  clicks: number;
  anfos: number;
  hard_bounces: number;
  unsubscribed: number;
  open_rate: number | string | null;
  click_rate: number | string | null;
  anfo_rate: number | string | null;
  etkp: number | string | null;
  cpa_revenue: number | string;
  actual_revenue: number | string;
}

export interface TimelineSummary {
  sends: number;
  recipients: number;
  opens: number;
  unique_opens: number;
  clicks: number;
  anfos: number;
  cpa_revenue: number;
  actual_revenue: number;
  open_rate: number;
  click_rate: number;
  anfo_rate: number;
  etkp: number;
}

export const EMPTY_SUMMARY: TimelineSummary = {
  sends: 0,
  recipients: 0,
  opens: 0,
  unique_opens: 0,
  clicks: 0,
  anfos: 0,
  cpa_revenue: 0,
  actual_revenue: 0,
  open_rate: 0,
  click_rate: 0,
  anfo_rate: 0,
  etkp: 0,
};

export const num = (value: unknown): number => {
  const n = typeof value === 'number' ? value : parseFloat(String(value ?? ''));
  return Number.isFinite(n) ? n : 0;
};
